'use es6';

import { memo } from 'react';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CalleeNumbersSkeleton({
  phoneNumbers,
  calleeIndex
}) {
  return [...Array(phoneNumbers)].map((_item, index) => /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "200",
    as: "div",
    children: [/*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "16px",
      blockSize: "16px",
      display: "inline-block",
      marginInlineEnd: "100"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "24px",
      blockSize: "16px",
      display: "inline-block",
      marginInlineEnd: "100"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "120px",
      blockSize: "16px",
      display: "inline-block",
      marginInlineEnd: "100"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      inlineSize: "80px",
      blockSize: "16px",
      display: "inline-block",
      marginInlineEnd: "100"
    })]
  }, `number-placeholder_${calleeIndex}-${index}`));
}
function CalleesSkeleton({
  showCalleeNames
}) {
  const calleeLength = showCalleeNames ? 2 : 1;
  return /*#__PURE__*/_jsx(View, {
    "data-selenium-test": "callees-skeleton",
    marginBlockStart: "300",
    as: "div",
    children: [...Array(calleeLength)].map((value, index) => /*#__PURE__*/_jsxs(View, {
      marginInline: "300",
      marginBlockEnd: "0",
      as: "div",
      children: [showCalleeNames ? /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "152px",
        blockSize: "16px",
        marginBlockEnd: "400"
      }) : null, /*#__PURE__*/_jsx(CalleeNumbersSkeleton, {
        phoneNumbers: 4,
        calleeIndex: index
      })]
    }, `callee-placeholder_${index}`))
  });
}
export default /*#__PURE__*/memo(CalleesSkeleton);